import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KatchaAssetPipe } from './asset.pipe';
import { KatchaAssetService } from './asset.service';
import { KatchaAssetsPipe } from './assets.pipe';



@NgModule({
  declarations: [
    KatchaAssetPipe,
    KatchaAssetsPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KatchaAssetPipe,
    KatchaAssetsPipe
  ]
})
export class KatchaAssetModule {
  static forRoot(): ModuleWithProviders<KatchaAssetModule> {
    return {
      ngModule: KatchaAssetModule,
      providers: [
        KatchaAssetService
      ]
    }
  }
}
